/**
 * Check if a user is an internal EliseAI employee based on email domain
 */
export const isInternalUser = (email: string | undefined): boolean => {
  if (!email) return false;
  return email.endsWith('@meetelise.com') || email.endsWith('@eliseai.com');
};
